import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../src/constants';
export default StyleSheet.create({
  detailsRow: {
    display: 'flex',
    paddingRight: 0,
  },
  fullTextLabel: {
    // lineHeight: 16,
  },
  detailsText: {
    // lineHeight: 16,
    paddingTop: 5,
    paddingBottom: 5,
  },
  separator: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  detailsTextBorder:{
    borderWidth: 1,
  },
  root: {
    flexDirection: 'row',
    paddingVertical: 6,
    display: 'block'
  },
  itemLeft: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    float: 'left',
  },
   itemRight: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    marginRight: 12,
    float: 'right',
  },
  itemLabel: {
    color: PALETTE.secondaryText,
  },
});

export const defaultColumnWidths = [0.6, 0.4];
